import React, { Component } from 'react';
// import './App.css';
import { Layout, Menu, Icon, Button, Descriptions } from 'antd';
import Review from './components/Review/Review';
import About from './components/Review/About'
import Settings from './components/Review/Settings'
import Settings2 from './components/Review/Settings2'
import Review2 from './components/Review/Review2';
import Docs from './components/Review/Docs';



const { Header, Content, Footer, Sider } = Layout;

class App extends Component {
  
  state = {
    page: 'home',
    settings: {
      imgEndPoint: 'http://ec2-52-9-172-104.us-west-1.compute.amazonaws.com:8081/api/links/review',
      dataEndPoint: '',
      saveEndPoint: ''
    }
  }

  showPage = (page) => {
    this.setState({
      page: page
    })
  }

  updateSettings = (settings) => {
    this.setState({
      settings,
      page: 'review'
    })
  }

  render () {
    return (
        <Layout>       
          <Layout>
            <Header className="header">
              <div className="logo" />
              <Menu
                theme="dark"
                mode="horizontal"
                defaultSelectedKeys={['Three']}
                style={{ lineHeight: '64px' }}
              >
                <Menu.Item onClick={() => this.showPage('review')} key="One">Review</Menu.Item>
                <Menu.Item onClick={() => this.showPage('settings')} key="Two">Settings</Menu.Item>
                <Menu.Item onClick={() => this.showPage('home')} key="Three">About</Menu.Item>
                <Menu.Item onClick={() => this.showPage('docs')} key="Four">Get Started</Menu.Item>
              </Menu>
            </Header>
            {this.state.page === "home" 
              ? <About showPage={this.showPage}/> //show home page without the content
              : <Content style={{ margin: '24px 16px 0'}}>
                  {this.state.page === "review" && <Review2 showPage={this.showPage} endpoints={this.state.settings}/>}
                  {this.state.page === "settings" && <Settings2 showPage={this.showPage} updateSettings={this.updateSettings} userSettings={this.state.settings}/> }
                  {this.state.page === "docs" && <Docs showPage={this.showPage}/>}
                  <br />
                  <br />
                </Content>
            }
            

            <Footer style={{ backgroundColor: '#0d1426', color: 'white', textAlign: 'center'}}>Ant Design ©2018 Created by Ant UED</Footer>
          </Layout>
        </Layout>
    );
  }
}

export default App;
